export default ['ru-ru', 'en-en'];